<ng-container *transloco="let t; prefix: 'sign-up-plan-dialog'">
    <div
        mat-dialog-title
        class="dialog-title-container"
    >
        <h2 class="dialog-title">{{ t("Title") }}</h2>
        <button mat-icon-button (click)="close()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">
        <div class="plan-type-toggle-container" *ngIf="!showForm">
            <span class="toggle-label" [class.active]="planType === 'monthly'">{{ t("BillingCycle.MonthlyLabel") }}</span>
            <mat-slide-toggle 
                class="v2-mdc-switch small" 
                [checked]="planType === 'annual'"
                (change)="onPlanTypeChange($event.checked)">
            </mat-slide-toggle>
            <span class="toggle-label" [class.active]="planType === 'annual'">{{ t("BillingCycle.YearlyLabel") }}</span>
        </div>
        <div class="plan-cards-container" *ngIf="!showForm">
            <div 
                *ngFor="let edition of editions; let i = index"
                class="plan-card"
                [class.selected]="selectedPlan === i"
                (click)="onPlanSelect(i)"
            >
                <div class="plan-header">
                    <h3 class="plan-name">{{ edition.title }}</h3>
                    <div class="plan-price">
                        {{ getPlanPrice(edition) | currency:'BRL':'symbol':'1.2-2' }}/{{ planType === 'monthly' ? t("BillingCycle.Monthly") : t("BillingCycle.Yearly") }}
                    </div>
                </div>
                <ul class="plan-features">
                    <li *ngFor="let highlight of edition.highlights" class="feature-item">
                        <mat-icon class="check-icon">check</mat-icon>
                        <span [innerHTML]="highlight.text"></span>
                    </li>
                </ul>
            </div>
        </div>

        <form [formGroup]="signUpForm" *ngIf="showForm" class="sign-up-form">
            <div class="form-section">
                <h3 class="section-title">{{ t("CreditCardSection.Title") }}</h3>
                <div class="form-row">
                    <mat-form-field class="form-field-full">
                        <mat-label>{{ t("CreditCardSection.CardHolderName") }}</mat-label>
                        <input matInput formControlName="cardHolderName" required>
                        <mat-error *ngIf="signUpForm.get('cardHolderName')?.hasError('required') && signUpForm.get('cardHolderName')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-full">
                        <mat-label>{{ t("CreditCardSection.CardNumber") }}</mat-label>
                        <input matInput formControlName="cardNumber" required>
                        <mat-error *ngIf="signUpForm.get('cardNumber')?.hasError('required') && signUpForm.get('cardNumber')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-half">
                        <mat-label>{{ t("CreditCardSection.Expiry") }}</mat-label>
                        <input matInput formControlName="cardExpiry" [placeholder]="t('CreditCardSection.ExpiryPlaceholder')" required>
                        <mat-error *ngIf="signUpForm.get('cardExpiry')?.hasError('required') && signUpForm.get('cardExpiry')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field-half">
                        <mat-label>{{ t("CreditCardSection.CVC") }}</mat-label>
                        <input matInput formControlName="cardCvc" required>
                        <mat-error *ngIf="signUpForm.get('cardCvc')?.hasError('required') && signUpForm.get('cardCvc')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-section">
                <h3 class="section-title">{{ t("BillingSection.Title") }}</h3>
                <div class="form-row">
                    <mat-form-field class="form-field-full">
                        <mat-label>{{ t("BillingSection.NameOrCompany") }}</mat-label>
                        <input matInput formControlName="billingName" required>
                        <mat-error *ngIf="signUpForm.get('billingName')?.hasError('required') && signUpForm.get('billingName')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-full">
                        <mat-label>{{ t("BillingSection.CpfCnpj") }}</mat-label>
                        <input matInput formControlName="billingCpfCnpj" required>
                        <mat-error *ngIf="signUpForm.get('billingCpfCnpj')?.hasError('required') && signUpForm.get('billingCpfCnpj')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-small">
                        <mat-label>{{ t("BillingSection.Cep") }}</mat-label>
                        <input matInput formControlName="billingCep" required [imask]="postalCodeMask" [unmask]="true">
                        <mat-error *ngIf="signUpForm.get('billingCep')?.hasError('required') && signUpForm.get('billingCep')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                        <mat-error *ngIf="invalidPostalCode">
                            {{ t("InvalidPostalCode") }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field-large">
                        <mat-label>{{ t("BillingSection.Street") }}</mat-label>
                        <input matInput formControlName="billingStreet" required>
                        <mat-error *ngIf="signUpForm.get('billingStreet')?.hasError('required') && signUpForm.get('billingStreet')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-medium">
                        <mat-label>{{ t("BillingSection.Neighborhood") }}</mat-label>
                        <input matInput formControlName="billingNeighborhood" required>
                        <mat-error *ngIf="signUpForm.get('billingNeighborhood')?.hasError('required') && signUpForm.get('billingNeighborhood')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field-medium">
                        <mat-label>{{ t("BillingSection.City") }}</mat-label>
                        <input matInput formControlName="billingCity" required>
                        <mat-error *ngIf="signUpForm.get('billingCity')?.hasError('required') && signUpForm.get('billingCity')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field-tiny">
                        <mat-label>{{ t("BillingSection.State") }}</mat-label>
                        <input matInput formControlName="billingState" maxlength="2" required>
                        <mat-error *ngIf="signUpForm.get('billingState')?.hasError('required') && signUpForm.get('billingState')?.touched">
                            {{ t("Errors.Required") }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-section">
                <div class="selected-plan-display" *ngIf="selectedPlan !== null && editions[selectedPlan]">
                    <h3 class="plan-name">{{ editions[selectedPlan].title }}</h3>
                    <div class="plan-price">
                        {{ getPlanPrice(editions[selectedPlan]) | currency:'BRL':'symbol':'1.2-2' }}/{{ planType === 'monthly' ? t("BillingCycle.Monthly") : t("BillingCycle.Yearly") }}
                    </div>
                </div>
            </div>

            <div class="accept-terms">
                <mat-checkbox formControlName="termsAccepted" class="terms-checkbox">
                    {{ t("Terms.Text") }} 
                    <a href="#" class="terms-link">{{ t("Terms.LicenseLink") }}</a> 
                    {{ t("Terms.AndText") }} 
                    <a href="#" class="terms-link">{{ t("Terms.PrivacyLink") }}</a>
                </mat-checkbox>
                <mat-error *ngIf="signUpForm.get('termsAccepted')?.hasError('required') && signUpForm.get('termsAccepted')?.touched" 
                        class="terms-error">
                    {{ t("Terms.Error") }}
                </mat-error>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions-container">
        <v2-button-wrapper
            color="primary"
            [text]="submitting ? t('Actions.Processing') : (showForm ? t('Actions.ContractPlan') : t('Actions.Continue'))"
            variant="raised"
            [icon]="showForm ? 'check' : 'arrow-right'"
            class="w-auto"
            type="button"
            [disabled]="submitting || selectedPlan === null"
            (click)="onContinue()"
        ></v2-button-wrapper>
    </mat-dialog-actions>
</ng-container>

